import { LogLevel } from './log-level.enum';

export const LOGGER_CONFIG = 'LOGGER_CONFIG';

export interface ILoggerConfig {
  level: LogLevel;
  logConsole?: boolean;
  logGlobalErrors?: boolean;
}
